// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, signInWithPopup } from "firebase/auth";
import { getFirestore, doc, getDoc, setDoc } from "firebase/firestore";
import { getFunctions, httpsCallable } from "firebase/functions"; // Import for Cloud Functions

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBzpYas5BAcVubWIKkCURbKzKo-gel47Yw",
  authDomain: "niram-616e5.firebaseapp.com",
  projectId: "niram-616e5",
  storageBucket: "niram-616e5.firebasestorage.app",
  messagingSenderId: "604775691532",
  appId: "1:604775691532:web:07bba4f95857c89ff14529"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const functions = getFunctions(app, 'us-central1'); // Specify region explicitly
const googleProvider = new GoogleAuthProvider();

const processGoogleSignInFunction = httpsCallable(functions, 'processGoogleSignIn');

export { app, auth, db, googleProvider, signInWithPopup, doc, getDoc, setDoc, processGoogleSignInFunction };
